import React, { FC } from 'react';
import { serializers } from 'services/sanity/serializers';
import { StyledBlockContent } from './rich-text.styles';

interface Props {
  blocks: any[] | any;
}

const RichText: FC<Props> = ({ blocks }) => {
  return <StyledBlockContent blocks={blocks} serializers={serializers} />;
};

export default RichText;
